module.exports = __webpack_public_path__ + "static/img/fullscreen-image_explore-your-options_en.29a5736.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/training/fullscreen-image_explore-your-options_en.png
// module id = y4ut
// module chunks = 0